const STEPS = [
  { icon: "ri-search-line", step: "01", title: "选一个场景", desc: "动图、短视频、录屏、表情包都按场景切片分类，先想清楚你要的情绪或名场面。" },
  { icon: "ri-scissors-2-line", step: "02", title: "点开看切片", desc: "每一段都替你切好重点，录屏带进度卡位，动图即点即循环，短视频节奏已卡准。" },
  { icon: "ri-bookmark-line", step: "03", title: "收藏或转发", desc: "看上的片段一键收藏，表情包存下来随时用。下次回来还在原场景等你。" },
];

const TOOLS = [
  { icon: "ri-flashlight-fill", label: "打开就能看" },
  { icon: "ri-user-unfollow-line", label: "免登录不打扰" },
  { icon: "ri-repeat-2-line", label: "动图循环不卡" },
  { icon: "ri-speed-up-line", label: "片段卡点快进" },
  { icon: "ri-device-line", label: "手机电脑都能看" },
  { icon: "ri-cloud-line", label: "无需下载安装" },
];

export default function HowTo() {
  return (
    <section id="howto" className="relative w-full overflow-hidden bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-2xl">
          <p className="flex items-center gap-2 text-xs font-medium tracking-widest text-primary-700">
            <i className="ri-tools-line" />
            HOW TO · 怎么找
          </p>
          <h2 className="mt-3 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
            三步，找到你想看的那段黑料色
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            不整复杂的搜索逻辑，这是一个「打开就能看」的轻工具：按场景切好，省去来回找的功夫。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {STEPS.map((s) => (
            <div
              key={s.step}
              className="flex flex-col rounded-xl border border-background-200 bg-background-100/50 p-6 transition hover:border-primary-200"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${s.icon} text-xl`} />
                </span>
                <span className="font-heading text-3xl font-black text-background-200">{s.step}</span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{s.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{s.desc}</p>
            </div>
          ))}
        </div>

        {/* 工具承诺条 */}
        <div className="mt-10 flex flex-wrap items-center gap-3 rounded-xl bg-foreground-950 p-5 md:gap-4 md:p-6">
          {TOOLS.map((t) => (
            <span
              key={t.label}
              className="flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/10 px-4 py-2 text-sm text-background-100 transition hover:bg-background-50/20"
            >
              <i className={`${t.icon} text-accent-400`} />
              {t.label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}